import { Injectable } from '@angular/core'
import { isServer } from '@mos/client/shared/utils'
import { AssetCompressionType, AssetCompressionTypes } from '@mos/shared/types'

@Injectable()
export class SupportedAssetDetectionService {
	private supportedTypes: AssetCompressionType[] = []
	private detected = false

	async detect(): Promise<AssetCompressionType[]> {
		if (isServer || this.detected) {
			return this.supportedTypes
		}

		// Never let asset-compression detection break app boot - fall back to no
		// compression support if both formats fail (MOS-WEB-9N).
		await this.testAvif()
			.catch(() => this.testWebP())
			.catch(() => undefined)
		this.detected = true
		return this.supportedTypes
	}

	private testAvif(): Promise<void> {
		return new Promise((resolve, reject) => {
			const avif = new Image()
			avif.onload = () => {
				this.supportedTypes.push(AssetCompressionTypes.AVIF)
				resolve()
			}
			avif.onerror = () => reject(new Error('AVIF detection image failed to load'))
			avif.src =
				'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='
		})
	}

	private testWebP(): Promise<void> {
		return new Promise((resolve, reject) => {
			const webp = new Image()
			webp.onload = () => {
				this.supportedTypes.push(AssetCompressionTypes.WEBP)
				resolve()
			}
			webp.onerror = () => reject(new Error('WebP detection image failed to load'))
			webp.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA=='
		})
	}
}
